import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { TankService } from 'src/app/services/tank.service';
import { UserService } from 'src/app/services/user.service';
import { Tank } from 'src/app/shared/models/Tank';
import { User } from 'src/app/shared/models/User';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  user!: User;
  tankList: Tank[] = [];
  selectedTank: Tank;

  currentTankForm: FormGroup;

  constructor(
    private tankService: TankService,
    private userService: UserService,
    private fb: FormBuilder,
    private router: Router
  ) { }

  logout() {
    this.user = null;
    this.userService.logout();
  }

  ngOnInit(): void {
    this.initUserData(); //cargo el user logueado

    /* this.tankService.tankObservableList.subscribe((tankList: Tank[]) => {
       this.tankList = tankList;
       // this.initSelectedTank();
     });*/

    this.currentTankForm = this.fb.group({
      CurrentTankId: ['']
    });

    this.currentTankForm.get('CurrentTankId').valueChanges
      .subscribe(newValue => {
        if (newValue !== this.selectedTank._id) {
          this.selectedTank = this.tankList.find(tank => tank._id === newValue);
          this.tankService.setCurrentTank(this.selectedTank);
        }
      });




  }

  get isAuth() {
    return this.user.token;
  }

  get isWebAccessBlockedPage(): boolean {
    return this.router.url.indexOf('web-access-disabled') !== -1;
  }

  onTankSelect(item: any) {
    console.log(item);
    this.tankService.setCurrentTank(item);
  }

  private initUserData() {
    this.userService.userObservable.subscribe((newUser) => {
      this.user = newUser;
      this.initTankList();
    });
  }

  private initTankList() {

    if (this.user.role == "superadmin") {
      this.tankService.getAll().subscribe((tankList: Tank[]) => {
        this.tankList = tankList;
        // console.log("this.tankList perfil superadmin", this.tankList)
        this.initSelectedTank();
      });

    }


    else if (this.user.role == "admin" || this.user.role == "cargador") {
      this.userService.getUserByTankAndId(this.user.tankId, this.user.id).subscribe((admin: User) => {
        console.log("admin", admin)
        this.tankService.getTank(admin[0].tanks[0]).subscribe((tank: Tank) => {
          this.tankList.push(tank);
          this.currentTankForm.setValue({ CurrentTankId: tank._id })
          console.log("this.tankList perfil admin", this.tankList)

          //this.initSelectedTank();
        });
      });
    }




  }

  /*private initSelectedTank() {
    this.tankService.getCurrentTank().subscribe((tank) => {
      if (tank && tank._id !== undefined) {
        this.selectedTank = tank;
        this.currentTankForm.setValue({ CurrentTankId: tank._id }); // Use the tank ID
      } else if (this.tankList.length > 0) {
        this.selectedTank = this.tankList[0]; // Update the selected tank
        this.currentTankForm.setValue({ CurrentTankId: this.selectedTank._id }); // Use the tank ID
        this.tankService.setCurrentTank(this.selectedTank);
      }
    });
  }*/

  private initSelectedTank() {
    this.tankService.getCurrentTank().subscribe((tank) => {
      if (tank && tank._id !== undefined && this.currentTankForm) {
        this.selectedTank = tank;
        this.currentTankForm.setValue({ CurrentTankId: tank._id }); // Use the tank ID
      } else if (this.tankList.length > 0) {
        this.selectedTank = this.tankList[0]; // Update the selected tank
        if (this.currentTankForm) {
          this.currentTankForm.setValue({ CurrentTankId: this.selectedTank._id }); // Use the tank ID
        }
        this.tankService.setCurrentTank(this.selectedTank);
      }
    });
  }
  isScreenBelow900(): boolean {
    return window.innerWidth < 900;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {

  }
}
